/**
 * Converts a base64 data URL (e.g. "data:image/png;base64,...") to a File object.
 * Returns null if the input is empty or not a valid data URL.
 */
export function dataUrlToFile(dataUrl, filename = 'firma.png') {
  if (!dataUrl) return null;

  const [header, base64Data] = dataUrl.split(',');
  if (!header || !base64Data) return null;

  const mimeMatch = header.match(/:(.*?);/);
  if (!mimeMatch) return null;
  const mime = mimeMatch[1];

  const byteString = atob(base64Data);
  const byteArray = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new File([byteArray], filename, { type: mime });
}
